import AmpersandState from 'ampersand-state';
import User from '../user/gd-user-basic';
import Task from '../task/gd-task';
import Moment from 'moment';

module.exports = AmpersandState.extend({
    idAttribute: 'id',
    props: {
        id: 'string',
        message: 'string',
        messageType: 'number',
        communicationFlow: 'number',

        date: 'object'
    },

    children: {
        user: User,
        task: Task
    },

    parse: function(obj) {

        obj.date = Moment.utc(obj.date).local();

        return obj;
    }
});